<div id="cart-container">
  <mat-horizontal-stepper labelPosition="bottom" [linear]="true" #stepper>

    <mat-step [stepControl]="firstFormGroup">
      <ng-template matStepLabel>Carrito</ng-template>

      <section id="primaryStep">

        <h1>
          Carrito de compras
          <span>({{userService.listProductsSession.length}} Productos)</span>
        </h1>

        <div id="contentProduct" fxLayout="row" fxLayoutAlign="space-around start" *ngIf="!diviceXs && !diviceSm">

          <div id="listaProducts" fxFlex="65">
            <ng-container *ngIf="userService.listProductsSession.length > 0">
              <div *ngFor="let product of userService.listProductsSession; let i=index" id="contentOfProduct"
                fxLayout="row" fxLayoutAlign="space-around center">


                <div id="img" fxFlex="20">
                  <img *ngIf="product.mainPhoto !=  undefined" mat-card-image src="{{product.mainPhoto}}"
                    [alt]="product.name">
                  <img *ngIf="product.mainPhoto === undefined" mat-card-image src="../../../../assets/img/caja.jpg "
                    [alt]="product.name">
                </div>

                <div id="contentText" fxFlex="70" fxLayout="row" fxLayoutAlign="space-between center">

                  <div id="infoOfProduct" fxFlex="40">
                    <h4>{{product.brand}}</h4>
                    <h2>{{product.name}}</h2>
                    <h5>{{product.reference}}</h5>
                  </div>

                  <div id="priceOfProduct" fxFlex="25">
                    <h3>{{product.price | currency:'COP'}} Und.</h3>

                    <div id="gessiPoints" fxLayout="row" fxLayoutAlign="start center">
                      <h4>{{product.points}} Gessis</h4>

                      <div id="btn-actInfoGessiPoints">
                        <span class="material-icons">help_outline</span>
                      </div>
                    </div>
                  </div>

                  <p id="getPoints" fxFlex="20">Ganas {{product.pointsRevenue}}<br />Gessis x unid.</p>

                  <div id="quantity" fxFlex="10">
                    <input (ngModelChange)="updateProductsInShoppingCart(i, quantity.value)" #quantity
                      class="form-control" matInput type="number" oninput="this.value = Math.abs(this.value)"
                      [(ngModel)]="product.quantity" min="1">
                  </div>
                </div>

                <a (click)="removeItem(product.id)" fxFlex="10">
                  <mat-icon>delete</mat-icon>
                </a>

              </div>

            </ng-container>

            <div *ngIf="userService.listProductsSession.length ===0">
              <h2>No tiene ningún producto seleccionado</h2>
            </div>
          </div>

          <div id="resumenOrder" fxFlex="30">

            <h2>Resumen de tu orden</h2>

            <p>
              <strong>Sub-total productos: </strong>
              <span>{{ userService.totalShoppingCartValueToPay | currency:'COP'}}</span>
            </p>
            <p> Acumula:
              <span>{{userService.totalShoppingCartRevenuePoints}}</span> Gessis
            </p>

            <hr />

            <h3>Redime tus Gessis</h3>
            <p id="points">
              <strong>Sub-total en Gessis: </strong>
              <span>{{ userService.totalShoppinCartValueToPayInPoints}} Gessis</span>
            </p>

            <div id="infoOrder">
              <p>Ten en cuenta que estos productos pueden llegar en envíos diferentes.</p>
              <p id="sendInfo">El costo de despacho NO está incluido en el precio.</p>
            </div>

            <button mat-raised-button color="primary" *ngIf="userService.listProductsSession.length >0" matStepperNext
              (click)="showInfo()" class="btn btn-primary btn-block font-weight-bold">Comprar</button>

            <div id="securityInfo" fxLayout="row" fxLayoutAlign="space-around start">
              <div id="security">
                <figure></figure>
                <figcaption>Pagos seguros</figcaption>
              </div>

              <div id="changes">
                <figure></figure>
                <figcaption>Cambios y devoluciones</figcaption>
              </div>

              <div id="happy">
                <figure></figure>
                <figcaption>Clientes felices</figcaption>
              </div>
            </div>
          </div>
        </div>

        <div id="contentProduct" fxLayout="column" *ngIf="diviceXs || diviceSm">

          <div id="listaProducts">
            <ng-container *ngIf="userService.listProductsSession.length > 0">

              <div *ngFor="let product of userService.listProductsSession; let i=index" id="contentOfProduct"
                fxLayout="column" fxLayoutAlign="center">

                <div id="firsContent" fxLayout="row" fxLayoutAlign="space-between center">
                  <div id="img" fxFlex="40">
                    <img *ngIf="product.mainPhoto !=  undefined" mat-card-image src="{{product.mainPhoto}}"
                      [alt]="product.name">
                    <img *ngIf="product.mainPhoto === undefined" mat-card-image src="../../../../assets/img/caja.jpg "
                      [alt]="product.name">
                  </div>

                  <div id="infoOfProduct">
                    <h4>{{product.brand}}</h4>
                    <h2>{{product.name}}</h2>
                    <h5>{{product.reference}}</h5>
                  </div>
                </div>

                <div id="contentText" fxLayout="row" fxLayoutAlign="space-around center">

                  <div id="priceOfProduct" fxFlex="40">
                    <h3>{{product.price | currency:'COP'}} Und.</h3>

                    <div id="gessiPoints" fxLayout="row" fxLayoutAlign="start center">
                      <h4>{{product.points}} Gessis</h4>

                      <div id="btn-actInfoGessiPoints">
                        <span class="material-icons">help_outline</span>
                      </div>
                    </div>
                  </div>

                  <p id="getPoints" fxFlex="25">Ganas {{product.pointsRevenue}}<br />Gessis x unid.</p>

                  <div id="quantity" fxFlex="20">
                    <input (ngModelChange)="updateProductsInShoppingCart(i, quantity.value)" #quantity
                      class="form-control" matInput type="number" oninput="this.value = Math.abs(this.value)"
                      [(ngModel)]="product.quantity" min="1">
                  </div>

                  <a (click)="removeItem(product.id)" fxFlex="10">
                    <mat-icon>delete</mat-icon>
                  </a>
                </div>

              </div>

            </ng-container>

            <div *ngIf="userService.listProductsSession.length ===0">
              <h2>No tiene ningún producto seleccionado</h2>
            </div>
          </div>

          <div id="resumenOrder">

            <h2>Resumen de tu orden</h2>

            <p>
              <strong>Sub-total productos: </strong>
              <span>{{ userService.totalShoppingCartValueToPay | currency:'COP'}}</span>
            </p>
            <p> Acumula: <span>{{userService.totalShoppingCartRevenuePoints}}</span> Gessis
            </p>

            <hr>

            <h3>Redime tus Gessis</h3>
            <p id="points">
              <strong>Sub-total en Gessis: </strong>
              <span>{{ userService.totalShoppinCartValueToPayInPoints}} Gessis</span>
            </p>

            <div id="infoOrder">
              <p>Ten en cuenta que estos productos pueden llegar en envíos diferentes.</p>
              <p id="sendInfo">El costo de despacho NO está incluido en el precio.</p>
            </div>

            <button mat-raised-button color="primary" *ngIf="userService.listProductsSession.length >0" matStepperNext
              (click)="showInfo()" class="btn btn-primary btn-block font-weight-bold">Comprar</button>
          </div>

        </div>

      </section>
    </mat-step>

    <mat-step *ngIf="userService.listProductsSession.length >0" errorMessage="La dirección es requerida.">
      <ng-template matStepLabel>Despacho</ng-template>

      <div *ngIf="!firebaseAuthService.loguedIn" class="headSecondStep">
        <h1>¡Hola!</h1>
        <p>
          Para continuar con tu compra
          <a *ngIf="!firebaseAuthService.loguedIn" color="primary" (click)="goToLogIn()"> Inicia Sesión </a>
        </p>
      </div>

      <div *ngIf="firebaseAuthService.loguedIn" class="headSecondStep">
        <h1>
          ¡Hola!<br />
          <span>{{firebaseAuthService.publicUser.displayName}}</span>
        </h1>
      </div>

      <section id="secondStep" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="!diviceXs && !diviceSm">

        <div id="contentLeft" fxFlex="65">
          <form [formGroup]="shippingAddressForm" (submit)="registerAddress()" *ngIf="!addressComplete"
            fxLayout="column" fxLayoutAlign="center">

            <h2>¿A donde enviamos tus productos?</h2>
            <h4>Indicanos donde quieres resivir o enviar tus productos.</h4>

            <mat-form-field>
              <input type="text" placeholder="Departamento" aria-label="Departamento" matInput [formControl]="departamentosCtrl" [matAutocomplete]="auto">
              
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="loadMunicipioByDepartamentoName($event.option.value)">
                <mat-option *ngFor="let departamento of filteredDepartamentos | async" [value]="departamento.departamento">
                  <span>{{departamento.departamento}}</span>
                </mat-option>
              </mat-autocomplete>

            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="Ciudad" aria-label="Ciudad" [formControl]="citiesCtrl"
                [matAutocomplete]="autoCity" >
              <mat-autocomplete #autoCity="matAutocomplete" (optionSelected)="setMunicipio($event.option.value)">
                <mat-option *ngFor="let city of filteredCities | async" [value]="city.municipio">
                  <span>{{city.municipio}}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field>
              <input matInput type="text" formControlName="neighborhood" placeholder="Barrio" />
            </mat-form-field>

            <mat-form-field>
              <input matInput type="text" formControlName="address" placeholder="Dirección" />
            </mat-form-field>

            <mat-form-field>
              <input matInput type="text" formControlName="addressSpecification"
                placeholder="Torre/ Apartamento/ Conjunto/ Oficina/ Condominio" />
            </mat-form-field>

            <button mat-raised-button color="primary" type="submit"
              [disabled]="shippingAddressForm.invalid">Continuar</button>

          </form>

          <div *ngIf="addressComplete" id="addressComplete">
            <p>Todos los productos se enviaran a la dirección indicada.</p>

            <h3>Dirección:</h3>

            <article>

              <p>{{shippingAddressForm.value.address}}, {{shippingAddressForm.value.addressSpecification}}
              </p>
              <p><strong>{{shippingAddressForm.value.neighborhood}}, {{citiesCtrl.value}} -
                  {{departamentosCtrl.value}}</strong></p>

              <a (click)="editAddress()">Editar <i class="material-icons md-24">edit</i></a>

            </article>

          </div>

          <div *ngIf="addressComplete" id="actionToPay">

            <h1>Pagar</h1>
            <p>En el siguiente paso podrás seleccionar tu medio de pago</p>

            <span id="info" *ngIf="!firebaseAuthService.loguedIn">* Recuerde, para continuar debe iniciar
              sesión. <a *ngIf="!firebaseAuthService.loguedIn" color="primary" (click)="goToLogIn()">
                <strong>Inicia Sesión</strong> </a></span>

            <button mat-raised-button disabled color="primary" matStepperNext
              *ngIf="!firebaseAuthService.loguedIn">Continuar</button>
            <button mat-raised-button color="primary" matStepperNext
              *ngIf="firebaseAuthService.loguedIn">Continuar</button>

          </div>
        </div>

        <div id="resumenOrder" fxFlex="30">

          <h2>Resumen de tu orden</h2>

          <p>
            <strong>Sub-total productos: </strong>
            <span>{{ userService.totalShoppingCartValueToPay | currency:'COP'}}</span>
          </p>

          <p id="points">
            <strong>Sub-total en puntos: </strong>
            <span>{{ userService.totalShoppinCartValueToPayInPoints}} Gessis</span>
          </p>

          <div id="costToPay">

            <div *ngIf="addressComplete" id="shippingCost">
              <p>
                <strong>Despacho: </strong>
                <span>{{shippingCost | currency:'COP'}}</span>
              </p>
            </div>

            <div id="totalToPay">
              <p>
                <strong>Total a pagar: </strong>
                <span *ngIf="!addressComplete">{{ userService.totalShoppingCartValueToPay |
                                    currency:'COP'}}</span>
                <span *ngIf="addressComplete">{{ userService.totalShoppingCartValueToPay+shippingCost |
                                    currency:'COP'}}</span>
              </p>
            </div>
          </div>


          <button matStepperPrevious id="backToStep">
            <i class="material-icons md-24">shopping_cart</i>
            Volver al carrito
          </button>

        </div>
      </section>

      <section id="secondStep" fxLayout="column" fxLayoutAlign="center" *ngIf="diviceXs || diviceSm">

        <div id="contentLeft">

          <form [formGroup]="shippingAddressForm" (submit)="registerAddress()" *ngIf="!addressComplete"
            fxLayout="column" fxLayoutAlign="center">

            <h2>¿A donde enviamos tus productos?</h2>
            <h4>Indicanos donde quieres resivir o enviar tus productos.</h4>

            <mat-form-field>
              <input type="text" placeholder="Departamento" aria-label="Departamento" matInput [formControl]="departamentosCtrl" [matAutocomplete]="auto">
              
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="loadMunicipioByDepartamentoName($event.option.value)">
                <mat-option *ngFor="let departamento of filteredDepartamentos | async" [value]="departamento.departamento">
                  <span>{{departamento.departamento}}</span>
                </mat-option>
              </mat-autocomplete>

            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="Ciudad" aria-label="Ciudad" [formControl]="citiesCtrl"
                [matAutocomplete]="autoCity" >
              <mat-autocomplete #autoCity="matAutocomplete" (optionSelected)="setMunicipio($event.option.value)">
                <mat-option *ngFor="let city of filteredCities | async" [value]="city.municipio">
                  <span>{{city.municipio}}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field>
              <input matInput type="text" formControlName="neighborhood" placeholder="Barrio" />
            </mat-form-field>

            <mat-form-field>
              <input matInput type="text" formControlName="address" placeholder="Dirección" />
            </mat-form-field>

            <mat-form-field>
              <input matInput type="text" formControlName="addressSpecification"
                placeholder="Torre/ Apartamento/ Conjunto/ Oficina/ Condominio" />
            </mat-form-field>

            <button mat-raised-button color="primary" type="submit"
              [disabled]="shippingAddressForm.invalid">Continuar</button>

          </form>

          <div *ngIf="addressComplete" id="addressComplete">
            <p>Todos los productos se enviaran a la dirección indicada.</p>

            <h3>Dirección:</h3>

            <article>

                <p>{{shippingAddressForm.value.address}}, {{shippingAddressForm.value.addressSpecification}}
                </p>
                <p><strong>{{shippingAddressForm.value.neighborhood}}, {{citiesCtrl.value}} -
                    {{departamentosCtrl.value}}</strong></p>

              <a (click)="editAddress()">Editar <i class="material-icons md-24">edit</i></a>

            </article>

          </div>

          <div *ngIf="addressComplete" id="actionToPay">

            <h1>Pagar</h1>
            <p>En el siguiente paso podrás seleccionar tu medio de pago</p>

            <span id="info" *ngIf="!firebaseAuthService.loguedIn">* Recuerde, para continuar debe iniciar
              sesión. <a *ngIf="!firebaseAuthService.loguedIn" color="primary" (click)="goToLogIn()">
                <strong>Inicia Sesión</strong> </a></span>

            <button mat-raised-button disabled color="primary" matStepperNext
              *ngIf="!firebaseAuthService.loguedIn">Continuar</button>
            <button mat-raised-button color="primary" matStepperNext
              *ngIf="firebaseAuthService.loguedIn">Continuar</button>

          </div>
        </div>

        <div id="resumenOrder">

          <h2>Resumen de tu orden</h2>

          <p>
            <strong>Sub-total productos: </strong>
            <span>{{ userService.totalShoppingCartValueToPay | currency:'COP'}}</span>
          </p>

          <p id="points">
            <strong>Sub-total en puntos: </strong>
            <span>{{ userService.totalShoppinCartValueToPayInPoints}} Gessis</span>
          </p>

          <div id="costToPay">

            <div *ngIf="addressComplete" id="shippingCost">
              <p>
                <strong>Despacho: </strong>
                <span>{{shippingCost | currency:'COP'}}</span>
              </p>
            </div>

            <div id="totalToPay">
              <p>
                <strong>Total a pagar: </strong>
                <span *ngIf="!addressComplete">{{ userService.totalShoppingCartValueToPay |
                                    currency:'COP'}}</span>
                <span *ngIf="addressComplete">{{ userService.totalShoppingCartValueToPay+shippingCost |
                                    currency:'COP'}}</span>
              </p>
            </div>
          </div>

          <button matStepperPrevious id="backToStep">
            <i class="material-icons md-24">shopping_cart</i>
            Volver al carrito
          </button>

        </div>

      </section>

    </mat-step>

    <mat-step *ngIf="userService.listProductsSession.length >0">
      <ng-template matStepLabel>Pagos</ng-template>

      <section id="thirdStep" fxLayout="row" fxLayoutAlign="space-between start" *ngIf="!diviceXs && !diviceSm">

        <div id="contentLeft" fxFlex="65">

          <h1 fxLayout="row" fxLayoutAlign="space-between center">
            <span>Elige tu medio de pago.</span>
            <a id="needReceipt" href="#">¿Necesitas factura?</a>
          </h1>

          <div id="typeOfpay">
            <p> ¿Como deseas pagar? </p>
            <form [formGroup]="typeOfPayForm">
              <mat-radio-group formControlName="type" aria-label="Selecciona un tipo de pago" fxLayout="row"
                fxLayoutAlign="space-around center">
                <mat-radio-button value="dinero">Dinero</mat-radio-button>
                <mat-radio-button value="puntos">Puntos</mat-radio-button>
              </mat-radio-group>
            </form>
          </div>

          <div id="address">

            <h3>Dirección:</h3>

            <article>

              <p>{{shippingAddressForm.value.address}}, {{shippingAddressForm.value.addressSpecification}}
              </p>
              <p><strong>{{shippingAddressForm.value.neighborhood}}, {{shippingAddressForm.value.city}} -
                  {{shippingAddressForm.value.state}}</strong></p>

              <div id="infoOrder">
                <p>Ten en cuenta que estos productos pueden llegar en envíos diferentes.</p>
                <p id="sendInfo">El costo de despacho NO está incluido en el precio.</p>
              </div>

            </article>
          </div>

          <div id="summaryProducts">

            <h2>Resumen de productos ({{userService.listProductsSession.length}})</h2>

            <div id="listaProducts" fxLayout="row wrap" fxLayoutAlign="start">
              <div *ngFor="let product of userService.listProductsSession; let i=index" id="contentOfProduct"
                fxLayout="row" fxLayoutAlign="space-around center" fxFlex="47">

                <div id="img" fxFlex="30">
                  <img *ngIf="product.mainPhoto !=  undefined" mat-card-image src="{{product.mainPhoto}}"
                    [alt]="product.name">
                  <img *ngIf="product.mainPhoto === undefined" mat-card-image src="../../../../assets/img/caja.jpg "
                    [alt]="product.name">
                </div>

                <div id="infoOfProduct">
                  <h4>{{product.brand}}</h4>
                  <h4 class="name">{{product.name}}</h4>
                  <h4>{{product.reference}}</h4>
                </div>

                <div id="priceOfProduct">
                  <h4>{{product.price*product.quantity | currency:'COP'}}</h4>
                  <h4>{{product.points}} Gessis</h4>
                  <h4>{{product.quantity}} Un.</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="resumenOrder" fxFlex="30">

          <h2>Resumen de tu orden</h2>

          <p>
            <strong>Sub-total productos: </strong>
            <span>{{ userService.totalShoppingCartValueToPay | currency:'COP'}}</span>
          </p>

          <p id="points">
            <strong>Sub-total en puntos: </strong>
            <span>{{ userService.totalShoppinCartValueToPayInPoints}} Gessis</span>
          </p>

          <div id="coupon">
            <h3>Agrega un cupón de descuento</h3>

            <form [formGroup]="couponForm" (submit)="validateCoupon()" fxLayout="row"
              fxLayoutAlign="space-around center">
              <mat-form-field>
                <input matInput type="text" formControlName="discountCoupon" placeholder="Cupon de Descuento" />
              </mat-form-field>

              <button mat-raised-button color="primary" type="submit" [disabled]="couponForm.invalid">Continuar</button>
            </form>
            <span id="invalidCoupon" *ngIf="invalidCouponState">Cupón inválido</span>

            <p id="validCoupon" *ngIf="stateOfCoupon">
              <strong>Cupón: </strong>
              <span>{{couponForm.value.discountCoupon}} (- {{discountCoupon | currency:'COP'}})</span>
            </p>
          </div>

          <div id="costToPay">

            <div id="shippingCost">
              <p>
                <strong>Despacho: </strong>
                <span>{{shippingCost | currency:'COP'}}</span>
              </p>
            </div>

            <div id="totalToPay">
              <p>
                <strong>Total a pagar: </strong>
                <span *ngIf="addressComplete && !stateOfCoupon">{{
                                    userService.totalShoppingCartValueToPay+shippingCost |
                                    currency:'COP'}}</span>

                <span *ngIf="addressComplete && stateOfCoupon">{{
                                    userService.totalShoppingCartValueToPay+shippingCost-discountCoupon |
                                    currency:'COP'}}</span>
              </p>
            </div>
          </div>

          <div id="actions" fxLayout="row" fxLayoutAlign="space-around center">
            <button matStepperPrevious id="backToStep">
              <i class="material-icons md-24">shopping_cart</i>
              Volver al carrito
            </button>

            <button id="pay" mat-raised-button color="primary" (click)="pay()" [disabled]="typeOfPayForm.invalid">
              Pagar
            </button>
          </div>

        </div>
      </section>

      <section id="thirdStep" fxLayout="column" fxLayoutAlign="center" *ngIf="diviceXs || diviceSm">

        <div id="contentLeft">

          <h1 fxLayout="row" fxLayoutAlign="space-between center">
            <span>Elige tu medio de pago.</span>
            <a id="needReceipt" href="#">¿Necesitas factura?</a>
          </h1>

          <div id="typeOfpay">
            <p> ¿Como deseas pagar? </p>
            <form [formGroup]="typeOfPayForm">
              <mat-radio-group formControlName="type" aria-label="Selecciona un tipo de pago" fxLayout="row"
                fxLayoutAlign="space-around center">
                <mat-radio-button value="dinero">Dinero</mat-radio-button>
                <mat-radio-button value="puntos">Puntos</mat-radio-button>
              </mat-radio-group>
            </form>
          </div>

          <div id="address">

            <h3>Dirección:</h3>

            <article>

                <p>{{shippingAddressForm.value.address}}, {{shippingAddressForm.value.addressSpecification}}
                </p>
                <p><strong>{{shippingAddressForm.value.neighborhood}}, {{citiesCtrl.value}} -
                    {{departamentosCtrl.value}}</strong></p>

              <div id="infoOrder">
                <p>Ten en cuenta que estos productos pueden llegar en envíos diferentes.</p>
                <p id="sendInfo">El costo de despacho NO está incluido en el precio.</p>
              </div>

            </article>
          </div>

          <div id="summaryProducts">

            <h2>Resumen de productos ({{userService.listProductsSession.length}})</h2>

            <div id="listaProducts" fxLayout="column" fxLayoutAlign="center">
              <div *ngFor="let product of userService.listProductsSession; let i=index" id="contentOfProduct"
                fxLayout="row" fxLayoutAlign="space-around center" fxFlex="47">

                <div id="img" fxFlex="30">
                  <img *ngIf="product.mainPhoto !=  undefined" mat-card-image src="{{product.mainPhoto}}"
                    [alt]="product.name">
                  <img *ngIf="product.mainPhoto === undefined" mat-card-image src="../../../../assets/img/caja.jpg "
                    [alt]="product.name">
                </div>

                <div id="infoOfProduct">
                  <h4>{{product.brand}}</h4>
                  <h4 class="name">{{product.name}}</h4>
                  <h4>{{product.reference}}</h4>
                </div>

                <div id="priceOfProduct">
                  <h4>{{product.price*product.quantity | currency:'COP'}}</h4>
                  <h4>{{product.points}} Gessis</h4>
                  <h4>{{product.quantity}} Un.</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="resumenOrder">

          <h2>Resumen de tu orden</h2>

          <p>
            <strong>Sub-total productos: </strong>
            <span>{{ userService.totalShoppingCartValueToPay | currency:'COP'}}</span>
          </p>

          <p id="points">
            <strong>Sub-total en puntos: </strong>
            <span>{{ userService.totalShoppingCartRevenuePoints}} Gessis</span>
          </p>

          <div id="coupon">
            <h3>Agrega un cupón de descuento</h3>

            <form [formGroup]="couponForm" (submit)="validateCoupon()" fxLayout="row"
              fxLayoutAlign="space-around center">
              <mat-form-field>
                <input matInput type="text" formControlName="discountCoupon" placeholder="Cupon de Descuento" />
              </mat-form-field>

              <button mat-raised-button color="primary" type="submit" [disabled]="couponForm.invalid">Continuar</button>
            </form>
            <span id="invalidCoupon" *ngIf="invalidCouponState">Cupón inválido</span>

            <p id="validCoupon" *ngIf="stateOfCoupon">
              <strong>Cupón: </strong>
              <span>{{couponForm.value.discountCoupon}} (- {{discountCoupon | currency:'COP'}})</span>
            </p>
          </div>

          <div id="costToPay">

            <div id="shippingCost">
              <p>
                <strong>Despacho: </strong>
                <span>{{shippingCost | currency:'COP'}}</span>
              </p>
            </div>

            <div id="totalToPay">
              <p>
                <strong>Total a pagar: </strong>
                <span *ngIf="addressComplete && !stateOfCoupon">{{
                                    userService.totalShoppingCartValueToPay+shippingCost |
                                    currency:'COP'}}</span>

                <span *ngIf="addressComplete && stateOfCoupon">{{
                                    userService.totalShoppingCartValueToPay+shippingCost-discountCoupon |
                                    currency:'COP'}}</span>
              </p>
            </div>
          </div>

          <div id="actions" fxLayout="row" fxLayoutAlign="space-around center">
            <button matStepperPrevious id="backToStep">
              <i class="material-icons md-24">shopping_cart</i>
              Volver al carrito
            </button>

            <button id="pay" mat-raised-button color="primary" (click)="pay()" [disabled]="typeOfPayForm.invalid">
              Pagar
            </button>
          </div>

        </div>
      </section>
    </mat-step>
  </mat-horizontal-stepper>
</div>
